/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 查看优惠券跳转链接类型
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: Array<good.Codebook>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/good/coupon/use-scope`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
